export default __webpack_public_path__ + "static/media/img-0644-north-macedonia-half-face.18a8efe8.png";